import enMessages from '../locales/al_AL.json';

const EnLang = {
  messages: {
    ...enMessages,
  },
  locale: 'al-AL',
};
export default EnLang;
